import { AutoMap } from "@automapper/classes";
import { EConditionPrelevement } from "src/app/domain/enums/condition-prelevement";
import { PrelevementAirDTO } from "./prelevement-air.dto";
import { PrelevementQualifSalleDTO } from "./prelevement-qualif-salle.dto";
import { PrelevementSurfaceDTO } from "./prelevement-surface.dto";

export class ZoneDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    zoneSalle: string = ''
    @AutoMap()
    dateDernierLavage?: string = ''
    @AutoMap()
    samplingDate: string = ''
    @AutoMap()
    conditionPrelevement: EConditionPrelevement = EConditionPrelevement.HorsActivite

    @AutoMap() 
    prelevementQualifSalle?: PrelevementQualifSalleDTO
    @AutoMap(() => [PrelevementAirDTO])
    prelevementAirList: PrelevementAirDTO[] = [];
    @AutoMap(() => [PrelevementSurfaceDTO])
    prelevementSurfaceList: PrelevementSurfaceDTO[] = [];

}
